import { FlowChartLink } from './flow-chart-link';
import { Country } from './country';

export class FlowChartNode {
  id: number;
  index?: number;
  label: string;
  code: string;
  x?: number;
  y?: number;
  fill?: string;
  links?: FlowChartLink[];
  taxJurisdiction?: Country;
}
